export default __webpack_public_path__ + "build/03db6d7b06d6e7c1e434a2fcbe27693a.png";